import { render } from "./Baptism.vue?vue&type=template&id=bfd259b4"
import script from "./Baptism.vue?vue&type=script&lang=js"
export * from "./Baptism.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__